// Pass View Report Generation
export const GENERATE_PASS_VIEW_REPORT = "GENERATE_PASS_VIEW_REPORT";

// Zone View Report Generation
export const GENERATE_ZONE_VIEW_REPORT = "GENERATE_ZONE_VIEW_REPORT";

export const GENERATE_TLOG_REPORT = "GENERATE_TLOG_REPORT";

// Report Generator Loader
export const REPORT_LOADER_START = "REPORT_LOADER_START";
export const REPORT_LOADER_STOP = "REPORT_LOADER_STOP";

// Reset Report State
export const RESET_REPORT_STATE = "RESET_REPORT_STATE";
